// Merge numeric timestamp values, so that the greatest timestamp "wins."
export function mergeTimestamps(
  left: Record<string, number>,
  right: Record<string, number>,
): Record<string, number> {
  const allKeys = [...new Set([...Object.keys(left), ...Object.keys(right)])];

  return allKeys.reduce((acc, key) => {
    const mergedValue = mergeTimestampValue(left[key], right[key]);

    return {
      ...acc,
      ...(mergedValue ? {[key]: mergedValue} : {}),
    };
  }, {});
}

function mergeTimestampValue(leftValue: number | undefined, rightValue: number | undefined) {
  if (!leftValue || !rightValue) {
    return rightValue || leftValue;
  }

  return Math.max(leftValue, rightValue);
}
